export default __webpack_public_path__ + "static/media/logo.168068b0.gif";